// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const visitorRoutes = [
  route('create', '/create', Create, meta('Adicionar novo Visitante/Pretador', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Visitante/Pretador', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Visitante/Pretador', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/visitor', visitorRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/routes.js